import io from "socket.io-client";
import differenceBy from "lodash/differenceBy";

export default class ChatSocket {
  constructor(params) {
    this.url = params.url;
    this.events = params.events;
    this.socket = io(this.url, {
      forceNew: true,
      multiplex: false
    });
    this.setUpSocketConnection();
  }

  setUpSocketConnection() {
    this.socket.on("connect_error", error => console.error(error.toString()));
    this.socket.on("error", error => console.error(error));
    this.events.forEach(event =>
      this.socket.on(`${event.name}`, event.handler)
    );
    this.socket.on("connect", () => {});
  }

  async tearDownConnection() {
    await this.socket.disconnect();
    this.events = [];
  }

  addEvents(events) {
    const newEvents = differenceBy(events, this.events, "name");
    this.events = [...this.events, ...newEvents];

    newEvents.forEach(singleEvent =>
      this.socket.on(`${singleEvent.name}`, singleEvent.handler)
    );
  }

  clearEvents() {
    this.events = [];
  }

  emit(action, params) {
    this.socket.emit(action, params);
  }

  connected() {
    return this.socket.connected;
  }

  connect() {
    return this.socket.connect();
  }

  disconnected() {
    return this.socket.disconnected;
  }

  disconnect() {
    return this.socket.disconnect();
  }
}
